import { render, staticRenderFns } from "./general_report_by_flat_by_service.vue?vue&type=template&id=aef0ac90&scoped=true&"
import script from "./general_report_by_flat_by_service.vue?vue&type=script&lang=js&"
export * from "./general_report_by_flat_by_service.vue?vue&type=script&lang=js&"
import style0 from "./general_report_by_flat_by_service.vue?vue&type=style&index=0&id=aef0ac90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef0ac90",
  null
  
)

export default component.exports